import React, { Component } from 'react'
import '../styles/ThemePicker.css'
import LAIcon from '../images/Themes/icon-la.png'
import VBNIcon from '../images/Themes/icon-vbn.png'
import AbattoirIcon from '../images/Themes/icon-abattoir.png'
import YakuzaIcon from '../images/Themes/icon-yakuza.png'
import TombeauIcon from '../images/Themes/icon-tombeau.png'
import LAIconDisabled from '../images/Themes/icon-disabled-la.png'
import VBNIconDisabled from '../images/Themes/icon-disabled-vbn.png'
import AbattoirIconDisabled from '../images/Themes/icon-disabled-abattoir.png'
import YakuzaIconDisabled from '../images/Themes/icon-disabled-yakuza.png'
import TombeauIconDisabled from '../images/Themes/icon-disabled-tombeau.png'
import ThemePickerItem from './ThemePickerItem'
import { injectIntl, defineMessages } from "react-intl"

class ThemePicker extends Component {

  render() {
    const {intl:{formatMessage}} = this.props
    const allowedThemes = Array.isArray(this.props.allowedThemes)
      ? this.props.allowedThemes
      : ['la', 'vbn', 'abattoir', 'yakuza', 'tombeau']
    const themes = [
      { id: 'la', title: formatMessage(messages.la), icon: LAIcon, iconDisabled: LAIconDisabled },
      { id: 'vbn', title: formatMessage(messages.vbn), icon: VBNIcon, iconDisabled: VBNIconDisabled },
      { id: 'abattoir', title: formatMessage(messages.slaughterhouse), icon: AbattoirIcon, iconDisabled: AbattoirIconDisabled },
      { id: 'yakuza', title: formatMessage(messages.yakuza), icon: YakuzaIcon, iconDisabled: YakuzaIconDisabled },
      { id: 'tombeau', title: formatMessage(messages.titletombeau), icon: TombeauIcon, iconDisabled: TombeauIconDisabled }
    ].filter(theme => allowedThemes.indexOf(theme.id) > -1)

    return (
      <ul className="theme-picker">
        <ThemePickerItem
          id="all"
          title={this.props.allRoomsLabel || formatMessage(messages.allRooms)}
          selected={this.props.selectedTheme}
          handleClick={() => this.props.handleChange("all")}
        />
        {themes.map(theme => (
          <ThemePickerItem
            singleTheme
            key={theme.id}
            id={theme.id}
            title={theme.title}
            icon={theme.icon}
            iconDisabled={theme.iconDisabled}
            selected={this.props.selectedTheme}
            handleClick={() => this.props.handleChange(theme.id)}
          />
        ))}
      </ul>
    )
  }
}

const messages = defineMessages({
  allRooms: {
    id: 'themePicker.allRooms',
    defaultMessage: 'Toutes les salles'
  },
  la: {
    id: 'themes.la',
    defaultMessage: 'Toutes les salles'
  },
  vbn: {
    id: 'themes.VBN',
    defaultMessage: 'Toutes les salles'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: 'Toutes les salles'
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: 'Toutes les salles'
  },
  titletombeau: {
    id: 'themes.tombeau',
    defaultMessage: 'Expédition Maudite'
  }
})

export default injectIntl(ThemePicker)



// WEBPACK FOOTER //
// ./src/components/ThemePicker.js